import { Box, Flex, Text, Image, useColorMode } from "@chakra-ui/react";

import { TextPrimary } from "theme";
import Link from "@components/Link";

import { IIndexable, MainMenuItem, SubMenuType } from "@customtypes/common";

import { getImageUrl } from "@utils/common";

interface OptionsProps {
  activeMenuKey: string;
  sidebarData: MainMenuItem;
  onClick(key: string): void;
  title: string;
}

const TOKEN = process.env.NEXT_PUBLIC_TOKEN;

const IconMappings: IIndexable = {
  ETH: {
    light: "/assets/images/sidebar/eth_light.svg",
    dark: "/assets/images/sidebar/eth_light.svg",
  },
  BNB: {
    light: "/assets/images/sidebar/bnb_light.svg",
    dark: "/assets/images/sidebar/bnb_dark.svg",
  },
  POLYGON: {
    light: "/assets/images/sidebar/polygon_light.svg",
    dark: "/assets/images/sidebar/polygon_dark.svg",
  },
  SD: {
    light: "/assets/images/sidebar/sd_light.svg",
    dark: "/assets/images/sidebar/sd_dark.svg",
  },
  HEDERA: {
    light: "/assets/images/sidebar/hedera_light.svg",
    dark: "/assets/images/sidebar/hedera_dark.svg",
  },
  FANTOM: {
    light: "/assets/images/sidebar/fantom_light.svg",
    dark: "/assets/images/sidebar/fantom_dark.svg",
  },
};

const Options = ({
  activeMenuKey,
  sidebarData,
  onClick,
  title,
}: OptionsProps) => {
  const { colorMode } = useColorMode();

  return (
    <>
      {title ? (
        <Text
          mb="1rem"
          fontWeight="700"
          fontSize="10px"
          lineHeight="16px"
          letterSpacing="0.5px"
        >
          GOVERNANCE
        </Text>
      ) : null}

      {sidebarData ? (
        <Flex
          bg={{ base: "backgroundPrimary", xl: "backgroundSecondary" }}
          borderRadius="1rem"
          p="1rem 0.5rem 1.5rem 1rem"
          flexDirection="column"
        >
          <Box key={sidebarData.key}>
            <Flex alignItems="center" mb="1rem">
              <Image
                src={
                  TOKEN &&
                  getImageUrl(
                    IconMappings[TOKEN?.toUpperCase()]
                      ? IconMappings[TOKEN?.toUpperCase()][colorMode]
                      : ""
                  )
                }
                alt="chain"
                width="20px"
                height="20px"
              />

              <TextPrimary
                ml="0.5rem"
                fontSize="14px"
                fontWeight="600"
                lineHeight="20px"
              >
                {sidebarData.name}
              </TextPrimary>
            </Flex>
            {sidebarData?.subMenus &&
              sidebarData.subMenus.map((data: SubMenuType) => (
                <Box
                  // isExternal={!data.is_internal_link}
                  cursor={data.is_disabled ? "not-allowed" : "pointer"}
                  key={data.key}
                  _hover={{
                    textDecoration: "none",
                  }}
                  onClick={() => onClick(data.key)}
                  bg={
                    activeMenuKey === data.key ? "backgroundPrimary" : "inherit"
                  }
                  ml="1.5rem"
                  p="8px 0"
                  borderRadius="8px"
                >
                  {/* TODO isExternal code */}
                  <Link link={data.link_url || ""}>
                    <Flex>
                      <Text
                        ml="0.5rem"
                        color={
                          activeMenuKey === data.key
                            ? "textPrimary"
                            : "textSecondary"
                        }
                        fontSize="14px"
                        fontWeight="600"
                        lineHeight="20px"
                      >
                        {data.name}
                      </Text>
                    </Flex>
                  </Link>
                </Box>
              ))}
          </Box>
        </Flex>
      ) : null}
    </>
  );
};

export default Options;
